module.exports = require('./helpers/bundle-url').getBundleURL('gl7es') + "logo.c51670a8.svg";